<template>
  <div>
    <div class="row">
      <div class="col-sm-6 pagination-info">
        <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
        <el-select
          class="select-default"
          v-model="pagination.perPage"
          placeholder="Per page"
          v-show="pagination.total > 6">
          <el-option
            class="select-default"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="perPageLabel(item)"
            :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="col-sm-6">
        <p-pagination class="pull-right"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="pagination.total"
                      v-show="pagination.total > 6">
        </p-pagination>
      </div>
    </div>
    <div class="row">
      <div v-for="batch in queriedData" class="col-lg-4" :key="getKey(batch)">
        <div class="card" style="padding-top:10px;">
          <div class="text-center">
            <div class="row">
              <h4>{{batchStatus(batch)}}</h4>
            </div>
          </div>
          <hr>
          <div class="prod-img-container">
            <img :src="batch.imageUrl" alt="Image">
          </div>
          <div style="text-align: center;">
            <h5>{{batch.product.data.name}}</h5>
          </div>
          <div class="text-center" style="height: 140px;">
            <div v-if="batch.product.data.size">
              <strong>Size:</strong> {{batch.product.data.size}}
            </div>
            <div v-if="batch.product.data.color">
              <strong>Color:</strong> {{batch.product.data.color}}
            </div>
            <div v-if="batch.product.data.style">
              <strong>Style:</strong> {{batch.product.data.style}}
            </div>
            <div v-if="batch.product.data.sku">
              <strong>SKU:</strong> {{batch.product.data.sku}}
            </div>
            <div v-if="batch.product.data.upc">
              <strong>UPC:</strong> {{batch.product.data.upc}}
            </div>
            <div v-if="showPrintFbaBtn(batch)">
              <strong>AMZ FBA FNSKU:</strong> {{batch.amzFnsku}}
            </div>
            <div v-if="batch.retailerName">
              <strong>Retailer:</strong> {{batch.retailerName}}
            </div>
          </div>
          <hr>
          <div class="text-center">
            <div class="row">
              <div class="col-md-5">
                <h6>Submitted
                  <br>
                  <div class="prod-detail-data">{{batch.createdAtFriendly}}</div>
                </h6>
              </div>
              <div class="col-md-3">
                <h6>Requested
                  <br>
                  <div class="prod-detail-data">{{batch.qty}}</div>
                </h6>
              </div>
              <div class="col-md-3">
                <h6>Created
                  <br>
                  <div class="prod-detail-data">{{batch.qtyCreated}}</div>
                </h6>
              </div>
            </div>
          </div>
          <hr>
          <div class="text-center" style="height: 40px;">
            <!-- <button type="button" @click.prevent="consoleLogAuthCodeBatch(props.row)" class="btn btn-fill btn-info btn-sm">Show Codes</button> -->
            <button type="button" v-if="showPrintBtn(batch)" @click.prevent="printAuthCodeBatch(batch)" class="btn btn-fill btn-info btn-sm">Print Auth Labels</button>
            <button type="button" v-if="showPrintBtnLoading(batch)" class="btn btn-info btn-sm" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              {{batch.status}}
            </button>
            <button type="button" v-if="showPrintFbaBtn(batch)" @click.prevent="printBatchFbaLabels(batch)" class="btn btn-fill btn-info btn-sm">Print FBA Labels</button>
            <button v-if="showPrintConfirmBtn(batch)" style="margin-top:5px" type="button" @click.prevent="confirmPrint(batch)" class="btn btn-fill btn-warning btn-sm">Close</button>
            <button v-if="showPrintConfirmBtnLoading(batch)" style="margin-top:5px" type="button" class="btn btn-warning btn-sm" disabled="disabled">
              <span class="btn-label">
                <i class="fa fa-circle-o-notch fa-spin"></i>
              </span>
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="false" class="row">
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="category">Records Per Page</div>
        </div>
        <div class="card-content row">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div v-if="false" class="col-sm-6">
            <div class="pull-right">
              <label>
                <input type="search" class="form-control input-sm" placeholder="Search records" v-model="searchQuery" aria-controls="datatables">
              </label>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table v-if="initialized"
                      class="table-striped"
                      :data="queriedData"
                      border
                      style="width: 100%">
              <el-table-column label="Product">
                <template slot-scope="props">
                  <div class="img-container">
                    <img :src="props.row.imageUrl" width="140" height="140">
                  </div>
                  {{props.row.product.data.name}}
                </template>
              </el-table-column>
              <el-table-column min-width="80" label="Status">
                <template slot-scope="props">
                  <strong>{{props.row.status}}</strong>
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                class="td-number td-quantity"
                label="Qty Requested">
                <template slot-scope="props">
                  {{props.row.qty}}
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                class="td-number td-quantity"
                label="Qty Created">
                <template slot-scope="props">
                  {{props.row.qtyCreated}}
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                class="td-number td-quantity"
                label="Requested">
                <template slot-scope="props">
                  {{props.row.createdAtFriendly}}
                </template>
              </el-table-column>
              <el-table-column
                min-width="80"
                class="td-number td-quantity"
                label="Printed">
                <template slot-scope="props">
                  {{props.row.printedAtFriendly}}
                </template>
              </el-table-column>
              <el-table-column label="" class="buttons"  min-width="100">
                <template slot-scope="props">
                  <!-- <button type="button" @click.prevent="consoleLogAuthCodeBatch(props.row)" class="btn btn-fill btn-info btn-sm">Show Codes</button> -->
                  <button type="button" v-if="showPrintBtn(props.row)" @click.prevent="printAuthCodeBatch(props.row)" class="btn btn-fill btn-info btn-sm">Print Auth Labels</button>
                  <button type="button" v-if="showPrintBtnLoading(props.row)" class="btn btn-info btn-sm" disabled="disabled">
                    <span class="btn-label">
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </span>
                    {{props.row.status}}
                  </button>
                  <button type="button" v-if="showPrintFbaBtn(props.row)" @click.prevent="printBatchFbaLabels(props.row)" class="btn btn-fill btn-info btn-sm">Print FBA Labels</button>
                  <button v-if="showPrintConfirmBtn(props.row)" style="margin-top:5px" type="button" @click.prevent="confirmPrint(props.row)" class="btn btn-fill btn-warning btn-sm">Confirm Print</button>
                  <button v-if="showPrintConfirmBtnLoading(props.row)" style="margin-top:5px" type="button" class="btn btn-warning btn-sm" disabled="disabled">
                    <span class="btn-label">
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </span>
                    Confirm
                  </button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6 pagination-info">
        <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
      </div>
      <div class="col-sm-6">
        <p-pagination class="pull-right"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="pagination.total"
                      v-show="pagination.total > 6">
        </p-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import _ from 'lodash'
  import moment from 'moment'
  import swal from 'sweetalert2'
  import axios from 'axios'
  import firebase from 'firebase'
  import db from '@/components/firebase/init'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  import { EventBus } from '@/eventBus'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  export default{
    components: {
      PPagination
    },
    mixins: [toolboxMixin],
    props: ['accountData', 'pathDymoAuthLabel', 'pathDymoFbaLabel', 'dymoPrinterName', 'showComplete'],
    computed: {
      queriedData () {
        return this.tableData
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        return this.pagination.total
      },
      watchPerPage () {
        return this.pagination.perPage * this.pagination.currentPage
      }
    },
    data () {
      return {
        user: {},
        initialized: false,
        pagination: {
          perPage: 3,
          currentPage: 1,
          perPageOptions: [3, 6, 12, 24, 48],
          total: 0,
          startAfter: false
        },
        tableData: [],
        prodImageMap: new Map(),
        batchIdIndexMap: new Map(),
        retailers: new Map(),
        authBarcodeBaseUrl: process.env.AUTH_BARCODE_BASE_URL
      }
    },
    methods: {
      async init () {
        this.user = await this.getCurrentUser()
        this.queryData()
        console.log('pathDymoAuthLabel', this.pathDymoAuthLabel)
      },
      batchStatus (batch) {
        if (batch.status === 'Processed') return 'Ready to Print'
        return batch.status
      },
      async getAuthCodeBatchesTable (data) {
        // let dataUserToken = data.userToken

        // let userToken = await admin.auth().verifyIdToken(dataUserToken)
        // let accountId = userToken.accountId

        let accountId = this.user.accountId

        let accountDoc = await db.collection('accounts').doc(accountId).get()
        let qtyAuthCodeBatches = accountDoc.data().qtyAuthCodeBatches
        console.log('qty account auth code batches', qtyAuthCodeBatches)
        let perPage = parseInt(data.perPage)
        let pageNum = parseInt(data.pageNum)
        let offset = perPage * (pageNum - 1)
        let batchDocs = []
        let qs = await db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).orderBy('createdAt', 'desc').limit(perPage).get()
        for (const doc of qs.docs) {
          console.log('doc', doc.data())
          let reg = {
            id: doc.id,
            data: doc.data()
          }
          reg.data.createdAtMillis = doc.data().createdAt.toMillis()
          batchDocs.push(reg)
        }
        let retVal = {
          data: {
            success: true,
            qtyAuthCodeBatches: qtyAuthCodeBatches,
            authCodeBatches: batchDocs
          }
        }
        console.log('returning', retVal)
        return retVal
      },
      async getAuthCodeBatches () {
        let qs = await db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).get()
        for (const batchDoc of qs.docs) {

        }
      },
      async getAuthCodeBatchesTableData (data) {
        console.log('getting brand for id', this.accountData.activeBrand.id)
        let brandDoc = await db.collection('brands').doc(this.accountData.activeBrand.id).get()
        let qtyAuthCodeBatches = brandDoc.data().qtyAuthCodeBatches
        let perPage = parseInt(data.perPage)
        let pageNum = parseInt(data.pageNum)
        let offset = perPage * (pageNum - 1)
        let includeComplete = data.includeComplete
        let brandIds = []
        let ojbDocs = []
        let products = new Map()

        if (includeComplete) {
          let qs = await db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`)
                        .orderBy('createdAt', 'desc')
                        .offset(offset)
                        .limit(perPage)
                        .get()
          for (const doc of qs.docs) {
            let obj = {
              id: doc.id,
              data: doc.data()
            }
            obj.data.createdAtMillis = doc.data().createdAt.toMillis()
            obj.data.createdAtFriendly = moment(obj.data.createdAtMillis).format('LL')
            if (obj.data.printedAt === undefined || obj.data.printedAt === '') obj.data.printedAtFriendly = 'Never'
            else obj.data.printedAtFriendly = moment(obj.data.printedAt.toMillis()).format('LL')
            if (!products.get(obj.data.productId)) {
              let prodDoc = await db.collection(`brands/${doc.data().brandId}/products`).doc(obj.data.productId).get()
              products.set(prodDoc.id, {
                id: prodDoc.id,
                data: prodDoc.data()
              })
            }
            obj.data.product = products.get(obj.data.productId)
            ojbDocs.push(obj)
          }
        } else {
          let i = 0
          let qs = await db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`)
                        .orderBy('createdAt', 'desc')
                        .get()
          for (const doc of qs.docs) {
            if (doc.data().status === 'Complete') continue
            i = i + 1
            let obj = {
              id: doc.id,
              data: doc.data()
            }
            obj.data.createdAtMillis = doc.data().createdAt.toMillis()
            obj.data.createdAtFriendly = moment(obj.data.createdAtMillis).format('LL')
            if (obj.data.printedAt === undefined || obj.data.printedAt === '') obj.data.printedAtFriendly = 'Never'
            else obj.data.printedAtFriendly = moment(obj.data.printedAt.toMillis()).format('LL')
            if (!products.get(obj.data.productId)) {
              let prodDoc = await db.collection(`brands/${doc.data().brandId}/products`).doc(obj.data.productId).get()
              products.set(prodDoc.id, {
                id: prodDoc.id,
                data: prodDoc.data()
              })
            }
            obj.data.product = products.get(obj.data.productId)
            console.log('i, offset, perpage', [i, offset, perPage])
            if (i > offset && i <= (offset + perPage)) {
              console.log('pushing', obj)
              ojbDocs.push(obj)
            }
          }
          qtyAuthCodeBatches = i
        }
        return {
          success: true,
          qtyAuthCodeBatches: qtyAuthCodeBatches,
          authCodeBatches: ojbDocs
        }
      },
      async queryData () {
        if (_.isEmpty(this.user)) return []

        this.tableData = []

        let data = {}
        data.perPage = this.pagination.perPage
        data.pageNum = this.pagination.currentPage
        data.includeComplete = this.showComplete
        console.log('calling getAuthCodeBatchesTableData', data)

        let result = {}
        result.data = await this.getAuthCodeBatchesTableData(data)
        // let result = await this.getAuthCodeBatchesTable(data)

        console.log('getAuthCodeBatchesTableData', result)
        this.pagination.total = result.data.qtyAuthCodeBatches
        console.log('pagination data', this.pagination)
        let authCodeBatches = result.data.authCodeBatches
        for (const batchDoc of authCodeBatches) {
          if (this.prodImageMap.get(batchDoc.data.productId) === undefined) {
            let img = await this.prodImgUrl(batchDoc.data.product.id, batchDoc.data.product.data, '140x140x')
            this.prodImageMap.set(batchDoc.data.productId, img)
          }
          let obj = batchDoc.data
          obj.id = batchDoc.id
          obj.imageUrl = this.prodImageMap.get(batchDoc.data.productId)

          if (batchDoc.data.retailerId) {
            obj.amzFnsku = ''
            switch (batchDoc.data.retailerId) {
              case 'glo_L3ItcLEw7lsUjCiQEXOH':
                obj.amzFnsku = batchDoc.data.product.data.amazonCaFnsku
                break
              case 'glo_nF5xYARYPDGMCK1PF0O9':
                obj.amzFnsku = batchDoc.data.product.data.amazonComMxFnsku
                break
              case 'glo_EHHSqB0I4r7LxWDjyida':
                obj.amzFnsku = batchDoc.data.product.data.amazonDeFnsku
                break
              case 'glo_FCFuI44LQACPMs7rL126':
                obj.amzFnsku = batchDoc.data.product.data.amazonComAuFnsku
                break
              case 'glo_GPDGgMmu4cVst8aN9qbq':
                obj.amzFnsku = batchDoc.data.product.data.amazonCoJpFnsku
                break
              case 'glo_HF3CaF2a6IfuzF7au8pM':
                obj.amzFnsku = batchDoc.data.product.data.amazonCoUkFnsku
                break
              case 'glo_LxXsa3LCKg5BlTNZnt38':
                obj.amzFnsku = batchDoc.data.product.data.amazonComSgFnsku
                break
              case 'glo_PeGF9QEH1m8AfjEpk0pL':
                trobj.amzFnsku = batchDoc.data.product.data.amazonNlFnskuue
                break
              case 'glo_Q6LtxzYrvB8NHLTYgKm2':
                obj.amzFnsku = batchDoc.data.product.data.amazonInFnsku
                break
              case 'glo_Uc1QUTcjrY7pe03Xz0mC':
                obj.amzFnsku = batchDoc.data.product.data.amazonCnFnsku
                break
              case 'glo_UeA0kQ6NlxsQPhV0K9C9':
                obj.amzFnsku = batchDoc.data.product.data.amazonEsFnsku
                break
              case 'glo_cijPxc5dl3QqVyNBk15u':
                obj.amzFnsku = batchDoc.data.product.data.amazonAeFnsku
                break
              case 'glo_iq4zGbl9B6gcI6VQR0iW':
                obj.amzFnsku = batchDoc.data.product.data.amazonFrFnsku
                break
              case 'glo_kisMBpmKIada8O8bpz7C':
                obj.amzFnsku = batchDoc.data.product.data.amazonItFnsku
                break
              case 'glo_on46LxTzF4vlnsIRaw8I':
                obj.amzFnsku = batchDoc.data.product.data.amazonComBrFnsku
                break
              case 'glo_pKJnjyemmc4DBizTBXMv':
                obj.amzFnsku = batchDoc.data.product.data.amazonComTrFnsku
                break
              default:
                // assume amazon.com glo_7tloXM2pGzXLx1qSxP7W
                obj.amzFnsku = batchDoc.data.product.data.amazonComFnsku
                break
            }
            if (this.retailers.get(batchDoc.data.retailerId) === undefined) {
              let retailerDoc = null
              if (batchDoc.data.retailerId.substring(0, 4) === 'glo_') {
                retailerDoc = await db.collection('globalRetailers').doc(batchDoc.data.retailerId).get()
              } else {
                retailerDoc = await db.collection(`accounts/${this.user.accountId}/retailers`).doc(batchDoc.data.retailerId).get()
              }
              this.retailers.set(batchDoc.data.retailerId, {
                id: retailerDoc.id,
                data: retailerDoc.data()
              })
            }
            obj.retailerName = this.retailers.get(batchDoc.data.retailerId).data.name
          }
          this.tableData.push(obj)
          this.batchIdIndexMap.set(obj.id, this.tableData.length - 1)
          if (obj.status === 'Requested' || obj.status === 'Processing') this.monitorAuthCodeBatch(obj)
        }
        this.pagination.startAfter = result.data.lastDoc
        console.log(this.tableData)
        this.initialized = true
      },
      async queryData2 () {
        if (_.isEmpty(this.user)) return []

        this.tableData = []

        let data = {}
        data.userToken = await firebase.auth().currentUser.getIdToken()
        data.accountId = this.user.accountId
        data.perPage = this.pagination.perPage
        data.pageNum = this.pagination.currentPage
        data.includeComplete = this.showComplete
        console.log('calling getAuthCodeBatchesTableData', data)

        let getAuthCodeBatchesTableData = firebase.functions().httpsCallable('getAuthCodeBatchesTableData')
        let result = await getAuthCodeBatchesTableData(data)
        // let result = await this.getAuthCodeBatchesTable(data)

        console.log('getAuthCodeBatchesTableData', result)
        this.pagination.total = result.data.qtyAuthCodeBatches
        console.log('pagination data', this.pagination)
        let authCodeBatches = result.data.authCodeBatches
        for (const batchDoc of authCodeBatches) {
          if (this.prodImageMap.get(batchDoc.data.productId) === undefined) {
            let img = await this.prodImgUrl(batchDoc.data.product.id, batchDoc.data.product.data, '140x140x')
            this.prodImageMap.set(batchDoc.data.productId, img)
          }
          let obj = batchDoc.data
          obj.id = batchDoc.id
          obj.imageUrl = this.prodImageMap.get(batchDoc.data.productId)

          if (batchDoc.data.retailerId) {
            obj.amzFnsku = ''
            switch (batchDoc.data.retailerId) {
              case 'L3ItcLEw7lsUjCiQEXOH':
                obj.amzFnsku = batchDoc.data.product.data.amazonCaFnsku
                break
              case 'nF5xYARYPDGMCK1PF0O9':
                obj.amzFnsku = batchDoc.data.product.data.amazonComMxFnsku
                break
              case 'EHHSqB0I4r7LxWDjyida':
                obj.amzFnsku = batchDoc.data.product.data.amazonDeFnsku
                break
              case 'FCFuI44LQACPMs7rL126':
                obj.amzFnsku = batchDoc.data.product.data.amazonComAuFnsku
                break
              case 'GPDGgMmu4cVst8aN9qbq':
                obj.amzFnsku = batchDoc.data.product.data.amazonCoJpFnsku
                break
              case 'HF3CaF2a6IfuzF7au8pM':
                obj.amzFnsku = batchDoc.data.product.data.amazonCoUkFnsku
                break
              case 'LxXsa3LCKg5BlTNZnt38':
                obj.amzFnsku = batchDoc.data.product.data.amazonComSgFnsku
                break
              case 'PeGF9QEH1m8AfjEpk0pL':
                trobj.amzFnsku = batchDoc.data.product.data.amazonNlFnskuue
                break
              case 'Q6LtxzYrvB8NHLTYgKm2':
                obj.amzFnsku = batchDoc.data.product.data.amazonInFnsku
                break
              case 'Uc1QUTcjrY7pe03Xz0mC':
                obj.amzFnsku = batchDoc.data.product.data.amazonCnFnsku
                break
              case 'UeA0kQ6NlxsQPhV0K9C9':
                obj.amzFnsku = batchDoc.data.product.data.amazonEsFnsku
                break
              case 'cijPxc5dl3QqVyNBk15u':
                obj.amzFnsku = batchDoc.data.product.data.amazonAeFnsku
                break
              case 'iq4zGbl9B6gcI6VQR0iW':
                obj.amzFnsku = batchDoc.data.product.data.amazonFrFnsku
                break
              case 'kisMBpmKIada8O8bpz7C':
                obj.amzFnsku = batchDoc.data.product.data.amazonItFnsku
                break
              case 'on46LxTzF4vlnsIRaw8I':
                obj.amzFnsku = batchDoc.data.product.data.amazonComBrFnsku
                break
              case 'pKJnjyemmc4DBizTBXMv':
                obj.amzFnsku = batchDoc.data.product.data.amazonComTrFnsku
                break
              default:
                // assume amazon.com 7tloXM2pGzXLx1qSxP7W
                obj.amzFnsku = batchDoc.data.product.data.amazonComFnsku
                break
            }
            if (this.retailers.get(batchDoc.data.retailerId) === undefined) {
              let retailerDoc = await db.collection(`accounts/${this.user.accountId}/retailers`).doc(batchDoc.data.retailerId).get()
              this.retailers.set(batchDoc.data.retailerId, {
                id: retailerDoc.id,
                data: retailerDoc.data()
              })
            }
            obj.retailerName = this.retailers.get(batchDoc.data.retailerId).data.name
          }
          this.tableData.push(obj)
          this.batchIdIndexMap.set(obj.id, this.tableData.length - 1)
          if (obj.status === 'Requested' || obj.status === 'Processing') this.monitorAuthCodeBatch(obj)
        }
        this.pagination.startAfter = result.data.lastDoc
        console.log(this.tableData)
        this.initialized = true
      },
      monitorAuthCodeBatch (authCodeBatch) {
        db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).doc(authCodeBatch.id)
        .onSnapshot(doc => {
          this.tableData[this.batchIdIndexMap.get(doc.id)].status = doc.data().status
          this.tableData[this.batchIdIndexMap.get(doc.id)].qtyCreated = doc.data().qtyCreated
        })
      },
      prettyAddress (regRecord) {
        let address = ''
        if (regRecord.address1) address += regRecord.address1
        if (regRecord.address2) address += '<br>' + regRecord.address2
        if (regRecord.city || regRecord.state || regRecord.zip || regRecord.country) {
          let region = ''
          if (regRecord.city) region += regRecord.city
          if (regRecord.state) {
            if (region === '') region += regRecord.state
            else region += ', ' + regRecord.state
          }
          if (regRecord.zip) {
            if (region === '') region += regRecord.zip
            else region += ' ' + regRecord.zip
          }
          if (regRecord.country) {
            if (region === '') region += regRecord.country
            else region += ' ' + regRecord.country
          }
          if (region !== '') region = '<br>' + region
          address += region
        }
        return address
      },
      friendlyDateTime (timestamp) {
        if (timestamp === undefined || timestamp === '') return 'Never'
        else return moment(timestamp.seconds * 1000).format('LLL')
      },
      formatLastPrinted (timestamp) {
        // sfd = new SimpleDateFormat('MM-dd-YYYY')
        // return sfd.format(new Date(timestamp))
        // return timestamp.seconds
        if (timestamp === undefined || timestamp === '') return 'Never'
        else return moment(timestamp.seconds * 1000).format('l')
      },
      showPrintBtn (authCodeBatch) {
        return authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed'
      },
      showPrintBtnLoading (authCodeBatch) {
        return authCodeBatch.status === 'Requested' || authCodeBatch.stats === 'Processing' || authCodeBatch.status === 'Printing' || authCodeBatch.loading
        // return (
        //   authCodeBatch.status === 'Requested' || authCodeBatch.status === 'Processing' || authCodeBatch.status === 'Printing' ||
        //   (this.loading && (authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed'))
        // )
      },
      showPrintFbaBtn (authCodeBatch) {
        if ((authCodeBatch.status !== 'Processed' && authCodeBatch.status !== 'Printed') || authCodeBatch.loading) return false
        return authCodeBatch.amzFnsku !== undefined && authCodeBatch.amzFnsku !== ''
        // if (authCodeBatch.retailerId === '7tloXM2pGzXLx1qSxP7W') {
        //   return this.hasAmazonComFnsku(authCodeBatch)
        // } else if (authCodeBatch.retailerId === 'L3ItcLEw7lsUjCiQEXOH') {
        //   return !!authCodeBatch.product.data.amazonCaFnsku
        // }
      },
      showPrintConfirmBtn (authCodeBatch) {
        return authCodeBatch.status === 'Processed' || authCodeBatch.status === 'Printed'
      },
      showPrintConfirmBtnLoading (authCodeBatch) {
        return authCodeBatch.confirmingPrint && authCodeBatch.status === 'Printed'
      },
      hasAmazonComFnsku (authCodeBatch) {
        return !!authCodeBatch.product.data.amazonComFnsku
      },
      getKey (authCodeBatch) {
        return 'batch' + authCodeBatch.id
      },
      perPageLabel (item) {
        return item + ' per page'
      },
      confirmPrint (authCodeBatch) {
        swal.fire({
          title: 'Did this batch print correctly?',
          text: `For security your raw Authentic.net codes for this batch will be removed from our system and printing this batch will be permanently disabled.`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, disable printing!',
          buttonsStyling: false
        }).then(() => {
          db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).doc(authCodeBatch.id).update({printConfirmed: true, status: 'Complete'}).then(result => {
            authCodeBatch.printConfirmed = true
            authCodeBatch.status = 'Complete'
            swal.fire({
              title: 'Confirmed!',
              text: 'Printing for this batch has been confirmed and your Authentic.net codes have been fully secured.',
              type: 'success',
              confirmButtonClass: 'btn btn-success btn-fill',
              buttonsStyling: false
            })
            EventBus.$emit('batch-closed')
          })
        })
      },
      async printAuthCodeBatch (authCodeBatch) {
        try {
          authCodeBatch.status = 'Printing'

          let userToken = await firebase.auth().currentUser.getIdToken()
          let data = {
            userToken: userToken,
            authCodeBatchId: authCodeBatch.id,
            brandId: this.accountData.activeBrand.id
          }
          let getAccountAuthCodesByBatchId = firebase.functions().httpsCallable('getAccountAuthCodesByBatchId')
          let result = await getAccountAuthCodesByBatchId(data)

          // this.showNotify('test error message.', 'error', 'Error')
          console.log(result)
          let response = await axios.get(this.pathDymoAuthLabel)
          let labelXml = response.data
          var label = dymo.label.framework.openLabelXml(labelXml)
          var labelSet = new dymo.label.framework.LabelSetBuilder()
          var labelParams = dymo.label.framework.createLabelWriterPrintParamsXml({printQuality: dymo.label.framework.LabelWriterPrintQuality.Text})
          var records = []
          let i = 0
          for (const authCode of result.data.authCodes) {
            // console.log(doc.data().code)
            let code = this.prettyV2Code(authCode.data.code)
            records[i] = labelSet.addRecord()
            records[i].setText('BARCODE', `URL:${this.authBarcodeBaseUrl}${code}`)
            if (this.user.accountId !== 'ABHVeLLQ4zCxNUiqOfyG') {
              // records[i].setText('TEXT_PRODUCT', authCodeBatch.product.data.name)
              records[i].setText('TEXT_PRODUCT', this.productNameForLabel(authCodeBatch.product.data))
              records[i].setText('TEXT_CODE', code)
            }
            // records[i].setText('BARCODE', `URL:https://appbeta.authentic.net/authenticate?code=b452a838-5dbb-4217-a075-57957b8d2da9`)
            i++
          }
          console.log(records)
          let printResult = await label.printAsync(this.dymoPrinterName, labelParams, labelSet)
          await db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).doc(authCodeBatch.id).update({status: 'Printed', printedAt: firebase.firestore.FieldValue.serverTimestamp()})
          authCodeBatch.status = 'Printed'
          swal.fire({
            title: `Print Job Submitted`,
            text: 'Be sure to print and use these labels 1 time only then close this batch. If you re-print due to Dymo error or otherwise, be sure to destroy any labels that were printed previously in order to avoid duplicates.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          })
        } catch (err) {
          console.log(err)
          await db.collection(`brands/${this.accountData.activeBrand.id}/authCodeBatches`).doc(authCodeBatch.id).update({status: 'Printed', printedAt: firebase.firestore.FieldValue.serverTimestamp()})
          authCodeBatch.status = 'Printed'
          swal.fire({
            title: `Print Job Submitted`,
            text: 'Be sure to print and use these labels 1 time only then close this batch. If you re-print due to Dymo error or otherwise, be sure to destroy any labels that were printed previously in order to avoid duplicates.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          })
        }
      },
      async getFbaLabelPrintQty (batchQty) {
        try {
          let qtyResult = await swal.fire({
            title: 'Quantity',
            text: `This batch consists of ${batchQty} units, but you can change the quantity of Amazon FBA labels to print below:`,
            type: 'question',
            input: 'text',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            buttonsStyling: false,
            inputValue: batchQty
          })
          if (qtyResult.value) {
            let printQty = batchQty
            let isInt = /^[0-9]+$/
            if (isInt.test(qtyResult.value)) {
              printQty = Number(qtyResult.value)
              if (printQty >= 1 && printQty <= 500) return printQty
            }
            await swal.fire({
              title: 'Invalid Value',
              text: 'Sorry, the value must be an integer between 1 and 500.',
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
            return this.getFbaLabelPrintQty(batchQty)
          } else if (result.dismiss === Swal.DismissReason.cancel) return false
        } catch (err) {
          this.showNotify('Print failed to to cancellation or error.', 'danger', 'Cancelled')
        }
      },
      async printBatchFbaLabels (authCodeBatch) {
        authCodeBatch.loading = true

        let printQty = await this.getFbaLabelPrintQty(authCodeBatch.qty)
        if (!printQty) return false

        let response = await axios.get(this.pathDymoFbaLabel)
        let labelXml = response.data
        // let productDoc = await db.collection('products').doc(authCodeBatch.productId).get()
        let label = dymo.label.framework.openLabelXml(labelXml)
        let labelSet = new dymo.label.framework.LabelSetBuilder()
        let labelParams = dymo.label.framework.createLabelWriterPrintParamsXml({printQuality: dymo.label.framework.LabelWriterPrintQuality.Text})

        var records = []
        for (var i = 0; i < printQty; i++) {
          records[i] = labelSet.addRecord()
          records[i].setText('BARCODE', authCodeBatch.amzFnsku)
          // records[i].setText('TEXT_PRODUCT', authCodeBatch.product.data.name)
          records[i].setText('TEXT_PRODUCT', this.productNameForLabel(authCodeBatch.product.data))
        }

        console.log('records to be printed', records)
        console.log('dymoPrinterName', this.dymoPrinterName)
        await label.printAsync(this.dymoPrinterName, labelParams, labelSet)
        authCodeBatch.loading = false
        swal.fire({
          title: `Print Job Submitted`,
          text: 'Apply these labels per Amazon\'s instructions.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        })
      }
    },
    watch: {
      watchPerPage: function (newFrom, oldFrom) {
        this.queryData()
      },
      showComplete: function (newFrom, oldFrom) {
        this.queryData()
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }
</script>
<style>
.btn {
  margin-top: 2px;
  margin-bottom: 2px;
}
.prod-img-container {
  border-radius: 6px;
  display: block;
  height: 100px;
  overflow: hidden;
  width: 100px;
  margin: 0 auto;
  text-align: center;
}
.prod-img-container img {
  max-width: 100%;
  max-height: 100%;
}
.prod-detail-data {
  color: #9A9A9A;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/AuthCodeBatchesCards.vue